import { defineMessages } from 'react-intl';

const messages = defineMessages({
  awaitingPayment: {
    description: 'salesOrderStatus.awaitingPayment',
    defaultMessage: 'Awaiting Payment',
    id: 'GdXcuK',
  },
  onHold: {
    description: 'salesOrderStatus.onHold',
    defaultMessage: 'On Hold',
    id: '0wOstF',
  },
  awaitingShipment: {
    description: 'salesOrderStatus.awaitingShipment',
    defaultMessage: 'Awaiting Shipment',
    id: 'lpYpCJ',
  },
  pendingFulfillment: {
    description: 'salesOrderStatus.pendingFulfillment',
    defaultMessage: 'Pending Fulfillment',
    id: '4dj+6Q',
  },
  rejectedFulfillment: {
    description: 'salesOrderStatus.rejectedFulfillment',
    defaultMessage: 'Rejected Fulfillment',
    id: '3/41ea',
  },
  shipped: {
    description: 'salesOrderStatus.shipped',
    defaultMessage: 'Shipped',
    id: 'Uz9q59',
  },
  cancelled: {
    description: 'salesOrderStatus.cancelled',
    defaultMessage: 'Cancelled',
    id: 'CFfcvl',
  },
});

const awaitingPaymentId = 'awaiting-payment';
const onHoldId = 'on-hold';
const awaitingShipmentId = 'awaiting-shipment';
const pendingFulfillmentId = 'pending-fulfillment';
const rejectedFulfillmentId = 'rejected-fulfillment';
const shippedId = 'shipped';
const cancelledId = 'cancelled';

const awaitingPayment = {
  displayName: 'Awaiting Payment',
  translation: messages.awaitingPayment,
  pillTheme: awaitingPaymentId,
};

const awaitingShipment = {
  displayName: 'Awaiting Shipment',
  translation: messages.awaitingShipment,
  pillTheme: awaitingShipmentId,
};

const shipped = {
  displayName: 'Shipped',
  translation: messages.shipped,
  pillTheme: shippedId,
};

const cancelled = {
  displayName: 'Cancelled',
  translation: messages.cancelled,
  pillTheme: cancelledId,
};

const onHold = {
  displayName: 'On Hold',
  translation: messages.onHold,
  pillTheme: onHoldId,
};

const pendingFulfillment = {
  displayName: 'Pending Fulfillment',
  translation: messages.pendingFulfillment,
  pillTheme: pendingFulfillmentId,
};

const rejectedFulfillment = {
  displayName: 'Rejected Fulfillment',
  translation: messages.rejectedFulfillment,
  pillTheme: rejectedFulfillmentId,
};

export const SalesOrderStatus = {
  AWP: awaitingPayment,
  OHD: onHold,
  AWS: awaitingShipment,
  PDF: pendingFulfillment,
  RJF: rejectedFulfillment,
  COM: shipped,
  CAN: cancelled,
  AwaitingPayment: awaitingPayment,
  OnHold: onHold,
  AwaitingShipment: awaitingShipment,
  PendingFulfillment: pendingFulfillment,
  RejectedFulfillment: rejectedFulfillment,
  Shipped: shipped,
  Cancelled: cancelled,
};

// Matches DBO.OrderStatus
const intToStatus = {
  1: SalesOrderStatus.AwaitingPayment,
  2: SalesOrderStatus.AwaitingShipment,
  3: SalesOrderStatus.Shipped,
  4: SalesOrderStatus.Cancelled,
  5: SalesOrderStatus.OnHold,
  7: SalesOrderStatus.PendingFulfillment,
  9: SalesOrderStatus.RejectedFulfillment,
};

export const getSalesOrderStatusFromInt = (enumInt) => {
  return intToStatus[enumInt] ?? SalesOrderStatus.AwaitingShipment;
};

const idToStatus = {
  [awaitingPaymentId]: SalesOrderStatus.AwaitingPayment,
  [awaitingShipmentId]: SalesOrderStatus.AwaitingShipment,
  [shippedId]: SalesOrderStatus.Shipped,
  [cancelledId]: SalesOrderStatus.Cancelled,
  [onHoldId]: SalesOrderStatus.OnHold,
  [pendingFulfillmentId]: SalesOrderStatus.PendingFulfillment,
  [rejectedFulfillmentId]: SalesOrderStatus.RejectedFulfillment,
};

export const getSalesOrderStatusFromId = (enumId) => {
  return idToStatus[enumId] ?? SalesOrderStatus.AwaitingShipment;
};

export const getSalesOrderStatusIdFromStatus = (status) => {
  return Object.keys(intToStatus).find((key) => intToStatus[key] === status);
};
